import React from 'react';

function CardIcon8() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="25"
      fill="none"
      viewBox="0 0 38 25"
    >
      <g clipPath="url(#clip0_2_8270)">
        <path
          fill="#000"
          d="M35 .6H3c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z"
          opacity="0.07"
        ></path>
        <path
          fill="#D64D00"
          d="M35 1.6c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2h32z"
        ></path>
        <path
          fill="#FF8A00"
          d="M21.382 10.313c0 1.668-1.177 2.858-2.821 2.858h-1.549a.133.133 0 00-.12.08.129.129 0 00-.01.05v2.191a.13.13 0 01-.08.12.13.13 0 01-.05.01h-1.084a.13.13 0 01-.13-.13V7.585a.127.127 0 01.08-.12.129.129 0 01.05-.01h2.9c1.637 0 2.814 1.19 2.814 2.857zm-1.352 0c0-.958-.658-1.658-1.55-1.658h-1.468a.13.13 0 00-.13.13v3.05a.127.127 0 00.08.12c.016.007.033.01.05.01h1.468c.892.005 1.55-.695 1.55-1.652zm1.674 3.791a1.527 1.527 0 01.647-1.317c.423-.316 1.084-.48 2.055-.514l1.033-.036v-.303c0-.607-.41-.863-1.068-.863-.658 0-1.075.231-1.17.61a.127.127 0 01-.125.09h-1.022a.13.13 0 01-.13-.147c.152-.898.904-1.58 2.494-1.58 1.692 0 2.303.783 2.303 2.276v3.172a.128.128 0 01-.04.092.13.13 0 01-.092.037h-1.03a.13.13 0 01-.13-.13v-.236a.096.096 0 00-.118-.096.1.1 0 00-.05.027c-.31.334-.808.575-1.607.575-1.175 0-1.95-.607-1.95-1.657zm3.735-.687v-.246l-1.339.07c-.705.036-1.115.326-1.115.816 0 .444.376.69 1.034.69.893 0 1.42-.48 1.42-1.33zm2.316 4.6v-.919a.13.13 0 01.1-.125.132.132 0 01.057-.002c.158.03.318.044.479.044a1.23 1.23 0 001.245-.876l.067-.21a.133.133 0 000-.089l-2.145-5.47a.13.13 0 01.122-.18h1.04a.132.132 0 01.123.084l1.456 3.86a.131.131 0 00.125.087.132.132 0 00.125-.088l1.265-3.848a.13.13 0 01.126-.09h1.076a.134.134 0 01.132.116.134.134 0 01-.008.063l-2.295 6.076c-.528 1.413-1.433 1.773-2.43 1.773a1.959 1.959 0 01-.561-.066.131.131 0 01-.099-.14zM8.57 7a5.363 5.363 0 00-3.683 1.427.231.231 0 00-.029.31l.618.84a.236.236 0 00.362.027 3.823 3.823 0 012.738-1.11c2.12 0 3.227 1.584 3.227 3.15 0 1.7-1.163 2.898-2.835 2.921-1.292 0-2.266-.85-2.266-1.974a1.908 1.908 0 01.713-1.48.231.231 0 00.033-.324l-.65-.815a.236.236 0 00-.339-.034 3.43 3.43 0 00-.942 1.183 3.39 3.39 0 00-.337 1.47c0 1.935 1.655 3.452 3.775 3.464h.03c2.517-.032 4.337-1.884 4.337-4.415C13.322 9.393 11.655 7 8.57 7z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_8270">
          <path
            fill="#fff"
            d="M0 0H38V24H0z"
            transform="translate(0 .6)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CardIcon8;
